<template>
	<el-container>
		<div>
			<el-row type="flex" justify="center">
				<div style="width: 100%;">
					<img style="width: 100%;height: auto; " src="/img/webimg/logo.png" />
				</div>
			</el-row>


			<el-row type="flex" justify="center">
				<el-tabs class="tabsDelBorder" :style="{width:$myglobal.screenwidth+'px'}" v-model="activeName"
					@tab-click="handleClick">
					<el-tab-pane label="体检客户" name="vcode">
						<span slot="label" class="spanactive">
							<span style="font-size: 20px;">体检客户</span>

						</span>
						<div v-if="showvcode">
							<div class="divbgFill" style="height: 55px;background-image: url(/img/webimg/sj.png);">
							
							<!-- <div class="divbgFill" style="height: 55px;border:1px solid #f3f3f3; border-radius: 30px;"> -->
								<!-- <el-button type="text" style="font-size: 28px;" icon="el-icon-mobile-phone"></el-button> -->
								&emsp;<el-input  class="inputDelBorder"
									style="font-size: 18px; margin-top:8px;  width: 210px;" type="text" v-model="mobile"
									placeholder="请输入手机号"></el-input>

							</div>
							<br>
							<div class="divbgFill" style="height: 55px;background-image: url(/img/webimg/yzm.png);">

								&emsp;<el-input class="inputDelBorder"
									style="font-size: 18px; margin-top:8px; width: 140px;" type="text" v-model="vcode"
									placeholder="请输入验证码"></el-input>
								<el-button style="width: 70px;font-size: 15px;color: #000000;" type="text"
									@click="getVcode($event)">
									{{vcodetext}}
								</el-button>
							</div><br>
							<!-- <ul>
								<li>
									<el-input style="width: 260px;border:none;" type="text" v-model="mobile"
										placeholder="手机号"></el-input>
									<br><br>
								</li>
								<li>
									<el-input style="width: 150px;" v-model="vcode" placeholder="手机验证码"></el-input>
									<el-button style="width: 110px;" type="warning" @click="getVcode($event)">
										{{vcodetext}}</el-button>
									<br><br>
								</li>
							</ul> -->
							<el-button round style="width: 95%;font-size: 20px;" type="primary"
								@click="submitVcode($event)">登&emsp;录</el-button>
						</div>
					</el-tab-pane>

					<el-tab-pane label="企业账号" name="pwd">
						<span slot="label">

							<span class="spanactive" style="font-size: 20px;">企业账号</span>

						</span>
						<div v-if="showpwd">
							<div class="divbgFill" style="height: 55px; background-image: url(/img/webimg/zh.png);">

								&emsp;<el-input class="inputDelBorder"
									style="font-size: 18px;margin-top:8px; width: 200px;" type="text" v-model="username"
									placeholder="请输入账号"></el-input>

							</div>
							<br>
							<div class="divbgFill" style="height: 55px;background-image: url(/img/webimg/mm.png);">

								&emsp;<el-input class="inputDelBorder"
									style="font-size: 18px; margin-top:8px; width: 200px;" type="password" v-model="pwd"
									placeholder="请输入密码"></el-input>

							</div><br>
							<!-- <br>
							<span>密码：</span>
							<el-input style="width: 200px;" type="password" v-model="pwd" placeholder="请输入密码">
							</el-input>
							<br><br> -->
							<el-button round style="width: 95%;font-size: 20px;" type="primary"
								@click="submitPwd($event)">
								登&emsp;录</el-button>
							<!-- <button class="bluebutton" @click="submitPwd($event)">登  录</button> -->
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-row>
			<el-row>
				<label style="color:#c8c9cc;">
					<input type="checkbox" v-model="agree">已阅读并同意</input>

					<!-- <el-checkbox  v-model="agree">已阅读并同意</el-checkbox> -->
				</label>
				<el-divider direction="vertical"></el-divider>

				<span style="color: #40aaff;" @click="Showys">《隐私政策》</span>
			</el-row>
			
		</div>
		
	<el-dialog width="95%" title="隐私政策" :visible.sync="showysDiag" v-dialogDrag>
			<div style="overflow-y:scroll;text-align: left;height: 300px;">
					<li>
					<span
						class="spannormal">宁波鄞州和慈景康门诊部有限公司（以下简称“我们”）非常注重保护用户（“您”）的个人信息及隐私。我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的措施来保护您的个人信息。我们希望通过本《隐私制度》（以下简称“本隐私制度”）向您介绍在使用我们的产品/服务时对个人信息的处理规则。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本隐私制度的内容（重点内容我们已将字体加粗请您特别关注）。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私制度处理您的相关信息。如对本隐私制度有任何疑问，您可以通过本隐私制度“如何联系我们”中提供的方式与我们联系。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>本隐私制度将帮助您了解以下内容<br>
							一、我们收集的信息<br>
							二、我们如何使用收集的信息<br>
							三、未成年人保护<br>
							四、通知和修订</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>一、我们收集的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们会遵循合法、正当、必要的原则，仅收集实现下列目的所必要的信息。如果我们将信息用于本隐私制度未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会单独征求您的授权同意。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（一）在您使用服务时提交或产生的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>1. 您在注册、登录账号时提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">您需要至少提供手机号码以创建账号，并完善相关的网络身份识别信息（手机动态验证码、登录密码等）。如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的账号进行绑定用于快捷登录。我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>2. 您在预约时提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>您通过客服热线预约体检服务时，需要提供体检人的姓名、性别、身份证号（港澳台胞和外籍人士需提供护照号与出生日期）、联系方式（电话号码、地址等）、体检产品信息。您通过网络预约体检服务时，需在关联体检产品信息后，提供体检人的姓名、性别、身份证号（港澳台胞和外籍人士需提供护照号与出生日期）。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">为了向您提供本地体检产品、周边体检分院的查询服务，<b>当您通过系统授权开启设备的定位功能并使用基于位置提供的服务时，我们会收集您的位置信息以便为您推荐本地体检产品、周边的体检分院等信息</b>（您不需要手动输入所在位置就可获得相关信息，方便您进行消费决策等）。我们会使用有关技术获取您的位置信息，这些技术包括IP地址、GPS以及能够提供相关信息的WLAN（如Wi-Fi）接入点及基站等。您可以在浏览器设置中或移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。关闭定位服务不会影响您享受下单、预约等服务的基本功能。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>3. 您在到店享受体检服务过程中产生的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>您在我们合作的门诊部接受体检服务时，我们可能会通过前台的摄像头为您拍照并录入您的账号，用于核对您的身份以避免检测差错。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">您在享受体检服务过程中，我们的工作人员将记录您的健康生理信息，用于为您出具体检报告。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>4. 您在享受体检服务过程中自愿额外提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>在您注册账号后或享受体检服务的过程中，如果您愿意额外补充如下个人信息，将有助于我们向您提供更加准确的服务：包括您的出生日期、婚否、既往史、家族史、传染病史、药物过敏史等信息。若您不提供这些信息，将会影响到您后续体检服务的准确与规范，但不会影响使用产品服务的下单、预约和订单管理功能。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（二）其他体检人的个人信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">您可以通过为其他体检人购买、预约各类产品/服务，并提供该体检人的有关信息并确保已取得该体检人的授权。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>二、我们如何使用收集的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们严格遵守法律法规的规定及与您的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（一）向您提供体检服务</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">为了确保体检质量与安全，在体检过程中我们的工作人员需要核对您的身份（包括姓名、性别、年龄）以避免检测差错。
						为了便于您对订单信息和体检报告进行管理，我们会向您展示在使用我们服务过程中产生的订单信息和体检报告。在这些生成的订单信息和体检报告中，将可能包含您的身份信息、联络信息、健康生理信息等敏感信息，请您谨慎向他人展示或对外提供。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（二）运营改进和服务优化</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们可能将业务中收集的个人信息用于改进运营和提升服务水平，将已经匿名化的信息用于建立数据库并进行分析利用。例如通过匿名化的订单信息等进行统计分析，改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（三）向您推荐可能感兴趣的产品/服务并评估我们的推广效果</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们可能将订单信息、浏览及搜索信息、行为偏好、位置信息等您在使用某项服务中提供或产生的信息，以及您在使用其他服务中授权提供的信息结合起来，进行综合统计、分析以形成用户画像，用来向您发送推广短信，并评估我们的推广效果。
						<br>如您不希望接收我们给您发送的推广短信，可通过信息中相应的退订功能进行退订。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>三、未成年人保护</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">如果我们发现自己在未事先获得可验证的父母或法定监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>四、通知和修订</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。我们会通过在我们网站、客户端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本隐私政策。</span>
				</li>
			</div>
		</el-dialog>
	</el-container>
	
	
		<!-- <li><span class="spanbig">&emsp;隐私政策 </span></li> -->
				<!-- <li style="margin: 15px 15px;"> -->
<!-- 	<el-dialog width="95%" title="隐私政策" :visible.sync="showysDiag" v-dialogDrag>
			<div style="overflow-y:scroll;text-align: left;height: 300px;">
			
					<li>
					<span
						class="spannormal">**管理有限公司（以下简称“我们”）非常注重保护用户（“您”）的个人信息及隐私。我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的措施来保护您的个人信息。我们希望通过本《隐私政策》（以下简称
						“本隐私政策”）向您介绍在使用我们的产品/服务时对个人信息的处理规则。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本隐私政策的内容（重点内容我们已将字体加粗请您特别关注）。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。如对本隐私政策有任何疑问，您可以通过本隐私政策“如何联系我们”中提供的方式与我们联系。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>本隐私政策将帮助您了解以下内容<br>
							一、我们收集的信息<br>
							二、我们如何使用收集的信息<br>
							三、未成年人保护<br>
							四、通知和修订</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>一、我们收集的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们会遵循合法、正当、必要的原则，仅收集实现下列目的所必要的信息。如果我们将信息用于本隐私政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会单独征求您的授权同意。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（一）在您使用服务时提交或产生的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>1. 您在注册、登录账号时提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">您需要至少提供手机号码以创建账号，并完善相关的网络身份识别信息（手机动态验证码、登录密码等）。如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的账号进行绑定用于快捷登录。我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>2. 您在预约时提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>您通过客服热线预约体检服务时，需要提供体检人的姓名、性别、身份证号（港澳台胞和外籍人士需提供护照号与出生日期）、联系方式（电话号码、地址等）、体检产品信息。您通过网络预约体检服务时，需在关联体检产品信息后，提供体检人的姓名、性别、身份证号（港澳台胞和外籍人士需提供护照号与出生日期）。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">为了向您提供本地体检产品、周边体检分院的查询服务，<b>当您通过系统授权开启设备的定位功能并使用基于位置提供的服务时，我们会收集您的位置信息以便为您推荐本地体检产品、周边的体检分院等信息</b>（您不需要手动输入所在位置就可获得相关信息，方便您进行消费决策等）。我们会使用有关技术获取您的位置信息，这些技术包括IP地址、GPS以及能够提供相关信息的WLAN（如Wi-Fi）接入点及基站等。您可以在浏览器设置中或移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。关闭定位服务不会影响您享受下单、预约等服务的基本功能。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>3. 您在到店享受体检服务过程中产生的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>您在我们合作的门诊部接受体检服务时，我们可能会通过前台的摄像头为您拍照并录入您的账号，用于核对您的身份以避免检测差错。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">您在享受体检服务过程中，我们的工作人员将记录您的健康生理信息，用于为您出具体检报告。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>4. 您在享受体检服务过程中自愿额外提交的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal"><b>在您注册账号后或享受体检服务的过程中，如果您愿意额外补充如下个人信息，将有助于我们向您提供更加准确的服务：包括您的出生日期、婚否、既往史、家族史、传染病史、药物过敏史等信息。若您不提供这些信息，将会影响到您后续体检服务的准确与规范，但不会影响使用产品服务的下单、预约和订单管理功能。</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（二）其他体检人的个人信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">您可以通过为其他体检人购买、预约各类产品/服务，并提供该体检人的有关信息并确保已取得该体检人的授权。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>二、我们如何使用收集的信息</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们严格遵守法律法规的规定及与您的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（一）向您提供体检服务</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">为了确保体检质量与安全，在体检过程中我们的工作人员需要核对您的身份（包括姓名、性别、年龄）以避免检测差错。
						为了便于您对订单信息和体检报告进行管理，我们会向您展示在使用我们服务过程中产生的订单信息和体检报告。在这些生成的订单信息和体检报告中，将可能包含您的身份信息、联络信息、健康生理信息等敏感信息，请您谨慎向他人展示或对外提供。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（二）运营改进和服务优化</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们可能将业务中收集的个人信息用于改进运营和提升服务水平，将已经匿名化的信息用于建立数据库并进行分析利用。例如通过匿名化的订单信息等进行统计分析，改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>（三）向您推荐可能感兴趣的产品/服务并评估我们的推广效果</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们可能将订单信息、浏览及搜索信息、行为偏好、位置信息等您在使用某项服务中提供或产生的信息，以及您在使用其他服务中授权提供的信息结合起来，进行综合统计、分析以形成用户画像，用来向您发送推广短信，并评估我们的推广效果。
						<br>如您不希望接收我们给您发送的推广短信，可通过信息中相应的退订功能进行退订。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>三、未成年人保护</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">我们非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal">如果我们发现自己在未事先获得可验证的父母或法定监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。</span>
				</li>
				<li style="margin: 15px 15px;">
					<span class="spannormal"><b>四、通知和修订</b></span>
				</li>
				<li style="margin: 15px 15px;">
					<span
						class="spannormal">为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。我们会通过在我们网站、客户端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本隐私政策。</span>
				</li>
			</div>
		</el-dialog>
	 -->
</template>

<script>
	import member from '../apifunction/Member.js'
	import user from '../apifunction/User.js'
	
	export default {
		created() {
			this.timer = setInterval(this.timervcode, 1000);
		},
		data() {
			return {
				mobile: '',
				username: '',
				pwd: '',
				vcode: '',
				activeName: "vcode",
				vcodetext: '获取验证码',
				vcodes: 60,
				showvcode: true,
				showpwd: false,
				agree: true,
				showysDiag: false
			};
		},
		methods: {
			Showys() {
				this.showysDiag = true;
			},
			timervcode() {
				if (this.vcodetext == '获取验证码')
					return;
				// let i=Intl.parseInt(this.vcodetext.replace('s',''))-1;
				this.vcodes = this.vcodes - 1;
				if (this.vcodes <= 0)
					this.vcodetext = '获取验证码';
				else
					this.vcodetext = this.vcodes + 's';
			},
			handleClick() {
				if (this.activeName == "vcode") {
					this.showvcode = true;
					this.showpwd = false;
				} else {
					this.showvcode = false;
					this.showpwd = true;
				}
			},
			submitVcode() {
				if (this.mobile == '' || this.mobile.length != 11) {
					this.$message.info('请输入正确手机号！')
					return;
				}
				if (this.vcode == '') {
					this.$message.info('请输入验证码！')
					return;
				}
				if (!this.agree) {
					this.$message.info('请阅读《使用协议》和《隐私政策》')
					return;
				}
				if (this.vcodetext == '获取验证码') {
					this.$message.info('失效的验证码,请重新获取！')
					return;
				}
				this.$store.commit('$_removeStorage');
				member.LoginByVcode(this.mobile, this.vcode)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							let entdata = JSON.parse(ent.Data)
							this.$myglobal.setUserInfo(entdata.userinfo)
							this.$myglobal.userinfo = JSON.parse(entdata.userinfo)[0];
							this.$store.commit('$_setToken', entdata.token);
							this.gobook()

						} else
							this.$message.info(ent.Msg);
					})

			},
			submitPwd() {
				if (this.username == '') {
					this.$message.info('请输入账号！')
					return;
				}
				if (this.pwd == '') {
					this.$message.info('请输入密码！')
					return;
				}
				this.$store.commit('$_removeStorage');
				user.CanLogin(this.username, this.pwd)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							let entdata = JSON.parse(ent.Data)
							this.$myglobal.setUserInfo(entdata.userinfo)
							this.$myglobal.userinfo = JSON.parse(entdata.userinfo)[0];
							this.$store.commit('$_setToken', entdata.token);
							this.$router.push('mainclient');
						} else
							this.$message.info("账号或密码不对！");
					})
			},
			gobook() {
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu: true
					}

				}
				this.$router.push(data)

			},
			getVcode() {
				if (this.mobile == '' || this.mobile.length != 11) {
					this.$message.info('请输入正确手机号！')
					return;
				}
				member.GetVcode(this.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('验证码已发送！');
							this.vcodetext = '60s';
							this.vcodes = 60;
						} else
							this.$message.info(ent.Msg);
					})
			}
		},
	}
</script>

<style>
	.el-tabs__nav-wrap::after {
		height: 0;
	}

	/*去掉el-tab-pane切换时的蓝色下划线*/
	.el-tabs__active-bar {
		background: transparent;
	}
</style>
